import ObjectsAPI from '../api/Objects';
import * as ObjectConst from '../constants/Property';
import * as SearchConst from '../constants/Search';
import * as ActionTypes from '../constants/ActionTypes';

export const setSearchType = type => dispatch => {
    const searchType = type === ObjectConst.TYPE.RENT ? SearchConst.SEARCH_TYPE.RENTAL : SearchConst.SEARCH_TYPE.BUY;
    dispatch({
        type: ActionTypes.SET_SEARCH_TYPE,
        payload: {
            type: type,
            searchType: searchType
        }
    });
};

export const findObjects = requestParams => dispatch => {
    ObjectsAPI.getObjects(requestParams)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.SET_SEARCH_RESULT,
                payload: data
            });
        });
};

export const setHorizontalMode = isHorizontalMode => ({
    type: ActionTypes.SET_HORIZONTAL_MODE,
    payload: isHorizontalMode
});

export const setDateStart = dateStartMoment => ({
    type: ActionTypes.SET_DATE_START_SEARCH,
    payload: dateStartMoment
});

export const setDateEnd = dateEndMoment => ({
    type: ActionTypes.SET_DATE_END_SEARCH,
    payload: dateEndMoment
});

export const setTypeTerm = name => ({
    type: ActionTypes.SET_TYPE_TERM,
    payload: name
});

export const setLifestyles = name => ({
    type: ActionTypes.SET_LIFESTYLES,
    payload: name
});

export const setTypeApartments = name => ({
    type: ActionTypes.SET_TYPE_APARTMENTS,
    payload: name
});

export const setCountGuests = countGuests => ({
    type: ActionTypes.SET_COUNT_GUESTS,
    payload: countGuests
});

export const setCountBedrooms = countBedrooms => ({
    type: ActionTypes.SET_COUNT_BEDROOMS,
    payload: countBedrooms
});

export const setCountBathrooms = countBathrooms => ({
    type: ActionTypes.SET_COUNT_BATHROOMS,
    payload: countBathrooms
});

export const setCountBeds = countBeds => ({
    type: ActionTypes.SET_COUNT_BEDS,
    payload: countBeds
});

export const setOurExclusive = isExclusive => ({
    type: ActionTypes.SET_OUR_EXCLUSIVE,
    payload: isExclusive
});

export const setNewTypeValues = isNewType => ({
    type: ActionTypes.SET_NEW_TYPE_VALUES,
    payload: isNewType
});

export const setPoolValues = value => ({
    type: ActionTypes.SET_POOL_VALUES,
    payload: value
});

export const setGarageValues = value => ({
    type: ActionTypes.SET_GARAGE_VALUES,
    payload: value
});

export const setGardenValues = value => ({
    type: ActionTypes.SET_GARDEN_VALUES,
    payload: value
});

export const setFloorValues = value => ({
    type: ActionTypes.SET_FLOOR_VALUES,
    payload: value
});

export const setOrientationValues = value => ({
    type: ActionTypes.SET_ORIENTATION_VALUES,
    payload: value
});

export const setViewsValues = value => ({
    type: ActionTypes.SET_VIEWS_VALUES,
    payload: value
});

export const setConditionValues = value => ({
    type: ActionTypes.SET_CONDITION_VALUES,
    payload: value
});

export const setKitchenValues = value => ({
    type: ActionTypes.SET_KITCHEN_VALUES,
    payload: value
});

export const setMinYearOfConstruction = minYearOfConstruction => ({
    type: ActionTypes.SET_MIN_YEAR_OF_CONSTRUCTION,
    payload: minYearOfConstruction
});

export const setMaxYearOfConstruction = maxYearOfConstruction => ({
    type: ActionTypes.SET_MAX_YEAR_OF_CONSTRUCTION,
    payload: maxYearOfConstruction
});

export const setRangeYearOfConstruction = rangeYearOfConstruction => ({
    type: ActionTypes.SET_RANGE_YEAR_OF_CONSTRUCTION,
    payload: {
        min: rangeYearOfConstruction.min,
        max: rangeYearOfConstruction.max
    }
});

export const setAmenities = name => ({
    type: ActionTypes.SET_AMENITIES,
    payload: name
});

export const setEasyFurniture = isEasyFurniture => ({
    type: ActionTypes.SET_EASY_FURNITURE,
    payload: isEasyFurniture
});

export const setAddress = address => ({
    type: ActionTypes.SET_ADDRESS,
    payload: address
});

export const setPageSize = pageSize => ({
    type: ActionTypes.SET_PAGE_SIZE,
    payload: pageSize
});

export const setPage = page => ({
    type: ActionTypes.SET_PAGE,
    payload: page
});

export const setOrder = orderType => ({
    type: ActionTypes.SET_ORDER,
    payload: orderType
});

export const setRangeArea = rangeArea => ({
    type: ActionTypes.SET_RANGE_AREA,
    payload: {
        min: rangeArea.min,
        max: rangeArea.max
    }
});

export const setRangePrice = rangePrice => ({
    type: ActionTypes.SET_RANGE_PRICE,
    payload: {
        min: rangePrice.min,
        max: rangePrice.max
    }
});

export const setMinArea = minArea => ({
    type: ActionTypes.SET_MIN_AREA,
    payload: minArea
});

export const setMaxArea = maxArea => ({
    type: ActionTypes.SET_MAX_AREA,
    payload: maxArea
});

export const setMinPrice = minPrice => ({
    type: ActionTypes.SET_MIN_PRICE,
    payload: minPrice
});

export const setMaxPrice = maxPrice => ({
    type: ActionTypes.SET_MAX_PRICE,
    payload: maxPrice
});

export const setPlaceId = placeId => ({
    type: ActionTypes.SET_PLACE_ID,
    payload: placeId
});

export const setMapData = (centerLat,
                           centerLng,
                           placeId,
                           address,
                           boundMaxLat,
                           boundMinLat,
                           boundMaxLng,
                           boundMinLng) => ({
    type: ActionTypes.SET_MAP_DATA,
    payload: {
        centerLat: centerLat,
        centerLng: centerLng,
        placeId: placeId,
        address: address,
        boundMaxLat: boundMaxLat,
        boundMinLat: boundMinLat,
        boundMaxLng: boundMaxLng,
        boundMinLng: boundMinLng
    }
});

export const setMapDataFromPlaceAutoComplete = (placeAutoComplete) => {
    if (placeAutoComplete.place_id === undefined) {
        return setMapData(
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
        );
    }
    let geom = placeAutoComplete.geometry;

    return setMapData(
        geom.location.lat(),
        geom.location.lng(),
        placeAutoComplete.place_id,
        placeAutoComplete.formatted_address,
        geom.viewport !== undefined ? geom.viewport.getNorthEast().lat() : undefined,
        geom.viewport !== undefined ? geom.viewport.getSouthWest().lat() : undefined,
        geom.viewport !== undefined ? geom.viewport.getNorthEast().lng() : undefined,
        geom.viewport !== undefined ? geom.viewport.getSouthWest().lng() : undefined
    );
};

export const setIsShowAllFilters = isShowAllFilters => ({
    type: ActionTypes.SET_IS_SHOW_ALL_FILTERS,
    payload: isShowAllFilters
});

export const setIsShowAdvancedSearch = isShowAdvancedSearch => ({
    type: ActionTypes.SET_IS_SHOW_ADVANCED_SEARCH,
    payload: isShowAdvancedSearch
});



// WEBPACK FOOTER //
// ./src/actions/Search.js